<template>
	<div class="container">
		<div v-show="loading" class="loading">
			<i  class="fa fa-3x fa-spinner fa-spin"></i>
		</div>		
		<div class="row">
			<div class="col-md-12">
				<div class="widget-wrap">
					<div class="widget-container margin-top-0">
						<div class="widget-content">
							<div class="row">
								<div class="col-md-12">
									<div class="row w-section-header">
										<div class="col-xs-2 text-left">
											<router-link v-if="!transactions" to="/"><i class="zmdi zmdi-hc-2x zmdi-chevron-left"></i></router-link>
											<router-link v-else to="/transactions"><i class="zmdi zmdi-hc-2x zmdi-chevron-left"></i></router-link>
										</div>
										<div class="col-xs-8 center">
											<h1>{{downloads.downloads[0].product_name}} {{downloads.downloads[0].product_version}}</h1>
										</div>							                    	
										<div class="col-xs-2 text-right">
										</div>	                  						
									</div>
								</div>
							</div>						
							<div class="j-forms unit" v-if="error">
								<div class="error-message">
									<i class="fa fa-close"></i>
									<p>Ops, there was a problem!</p>
								</div>
							</div> 	          	   				
							<div class="row downloads">
								<div class="unit">
									<div v-bind:class="{ 'col-sm-4': otherDownloads.length != 0, 'col-sm-6': otherDownloads.length == 0,  }">
										<div class="row title"><h3><i class="zmdi zmdi-apple"></i> Apple OS X</h3></div>
										<span v-for="file in downloads.downloads">
											<div class="row line" v-if="file.operating_system == 'Windows/Mac OSX' || file.operating_system == 'Mac OSX'">
												<div class="btn-group">
													<button class="btn btn-primary btn-spaziami" @click="getToken(file.id_file)">v{{file.version}} {{file.architecture}} <i class="zmdi zmdi-download"></i></button>
												</div>
											</div>
										</span>
									</div>
									<div v-bind:class="{ 'col-sm-4': otherDownloads.length != 0, 'col-sm-6': otherDownloads.length == 0,  }">
										<div class="row title"><h3><i class="zmdi zmdi-windows"></i> Microsoft Windows</h3></div>
										<span v-for="file in downloads.downloads">
											<div class="row line" v-if="file.operating_system == 'Windows/Mac OSX' || file.operating_system == 'Windows'">
												<div class="btn-group">
													<button class="btn btn-primary btn-spaziami" @click="getToken(file.id_file)">v{{file.version}} {{file.architecture}} <i class="zmdi zmdi-download"></i></button>
												</div>
											</div>
										</span>
									</div>
									<div v-if="otherDownloads.length != 0" class="col-sm-4">
										<div class="row title"><h3><i class="zmdi zmdi-collection-text"></i> Manuals</h3></div>
										<span v-for="file in otherDownloads">
											<div class="row line">
												<div class="btn-group">
													<a v-bind:href="file.filepath" target="_blank"><button class="btn btn-primary btn-spaziami">{{file.filename}} <i class="zmdi zmdi-download"></i></button></a>
												</div>
											</div>
										</span>																												
									</div>
								</div>
							</div>			                
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import auth from '../auth'
	export default {
		data(){
			return{
				loading:false,
				error:false,				
				get downloads(){
					return JSON.parse(localStorage.getItem('downloads')) || 0;
				},
				get otherDownloads(){
					// al momento non gestisco il "type" dei vari file
					return JSON.parse(localStorage.getItem('other_downloads')) || 0;
				},
				get transactions(){
					if(localStorage.getItem('userhome')=='transaction')
						{
							return true
						}else{
							return false
						}					
				}
			}
		},
		methods:{
			getToken(id_file){
				var token_min = process.env.TOKEN_DURATION
				auth.getToken(this, id_file, token_min)
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Downloads.vue